import { render, staticRenderFns } from "./ProductEditorLog.vue?vue&type=template&id=76939e62&"
import script from "./ProductEditorLog.vue?vue&type=script&lang=js&"
export * from "./ProductEditorLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports